module.exports = __webpack_public_path__ + "83a4e4c0e2bc61a8108a34efd66923d8.png";